import type SVGType from 'types/svg.types';

const BankHeaderIcon: SVGType = (props) => (
  <svg
    width="48"
    height="44"
    viewBox="0 0 48 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M41.2568 27.0148C41.5004 28.5833 42.0385 32.5071 42.2532 33.8896C42.6632 36.5287 38.5743 37.3539 35.6904 38.114C31.4508 38.8892 27.4627 39.2307 26.5272 39.4018C24.9286 39.6941 22.9022 40.4525 21.3731 40.7321C19.8441 41.0117 19.5653 40.5974 16.0442 41.3964C12.523 42.1954 8.88554 42.7055 5.90715 42.3972C4.23635 42.2243 4.50538 35.6741 3.88766 33.5382C3.26995 31.4022 2.97472 28.1214 2.57646 25.5577C2.22077 23.268 1.97824 21.2467 1.81191 18.7956C1.60358 15.7257 5.73442 15.5192 10.53 14.6423C13.2725 14.1408 19.7393 13.1908 22.4148 12.4689C25.0902 11.747 28.1373 11.5776 31.4499 10.8167C34.1 10.208 37.223 10.097 38.0541 10.5396C39.3058 10.3107 39.2568 14.6004 39.5473 16.4705C39.9104 18.8081 40.9522 25.0542 41.2568 27.0148Z"
      fill="#F7FBFD"
      stroke="#0E273F"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M28.241 21.1718L27.8152 18.431C27.7509 18.0169 28.0329 17.62 28.4452 17.5447L32.4769 16.8074C32.8711 16.7353 33.2451 16.9835 33.3311 17.3743L33.9271 20.084C34.021 20.5107 33.7364 20.938 33.3059 21.0167L29.1039 21.7851C28.6916 21.8605 28.3053 21.5859 28.241 21.1718Z"
      fill="#0E273F"
    />
    <path
      d="M10.7115 32.4226C10.9605 32.4291 11.3199 32.5075 10.7654 32.7693"
      stroke="#0E273F"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <path
      d="M14.2771 30.1469C14.8938 30.5476 15.8636 31.7933 14.809 33.5706"
      stroke="#0E273F"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <path
      d="M17.9658 28.2756C18.9947 28.9498 20.6137 31.0434 18.859 34.025"
      stroke="#0E273F"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <path
      d="M44.6762 17.1759C45.0767 18.706 46.0075 22.5423 46.3605 23.891C47.0344 26.4655 43.0534 27.7715 40.2635 28.8696C36.1277 30.1439 32.1979 30.9572 31.2853 31.2384C29.7259 31.7188 27.7882 32.7134 26.2966 33.173C24.8049 33.6326 24.486 33.2539 21.0667 34.4664C17.6473 35.6789 14.0832 36.6181 11.0916 36.6655C9.41341 36.6922 9.01975 30.1494 8.19017 28.0997C7.3606 26.05 6.73604 22.824 6.08144 20.323C5.4968 18.0893 5.05172 16.1089 4.63902 13.6924C4.12211 10.6657 8.20728 9.96966 12.8855 8.52824C15.5609 7.70394 21.893 5.99143 24.4795 4.95603C27.0659 3.92063 30.0776 3.39016 33.2936 2.24031C35.8663 1.32043 38.9593 0.839121 39.8301 1.18027C41.0511 0.804058 41.4353 5.07377 41.9128 6.8981C42.5097 9.17852 44.1756 15.2633 44.6762 17.1759Z"
      fill="#F7FBFD"
      stroke="#0E273F"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M31.1477 12.9119L30.4492 10.2433C30.3431 9.83793 30.5817 9.40924 30.9822 9.28585L34.9214 8.07214C35.3043 7.95418 35.7 8.15779 35.8253 8.53714L36.6895 11.1546C36.8264 11.5692 36.5884 12.0288 36.17 12.1577L32.065 13.4225C31.6645 13.5459 31.2538 13.3173 31.1477 12.9119Z"
      fill="#0E273F"
    />
    <path
      d="M14.8611 26.1794C15.1092 26.1563 15.4744 26.1915 14.9496 26.5177"
      stroke="#0E273F"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <path
      d="M16.9717 23.4943C17.6251 23.8193 18.7148 24.9423 17.8459 26.8343"
      stroke="#0E273F"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <path
      d="M18.9357 21.6659C20.0264 22.2137 21.847 24.1025 20.4037 27.2746"
      stroke="#0E273F"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);

export default BankHeaderIcon;
